import React, { useState } from 'react';
import { connect } from 'unistore/react';
import { actions } from '../store/PlanStore';

import Modal from 'common/components/modals/Modal';
import Button from 'common/components/Button';
import { TranslatedMessage } from 'common/components/Intl';
import segment from 'common/segment';

const editAutoship = () => {
  window.location.href = '/account/membership';
};

const shopPods = () => {
  window.location.href = '/shop/pods';
};

const exitBuildYourPlan = () => {
  window.location = '/';
};

export function CartErrorModal({ clearErrors, error, errorCodes }) {
  const [modalActive, setModalActive] = useState(true);

  const onRequestClose = () => {
    setModalActive(false);
  };

  const errorKey = error.code;

  const reportableError = Object.keys(errorCodes).find(
    key => errorCodes[key] === errorKey
  );
  segment.track('AS Builder Error Viewed', { error_key: reportableError });

  const clearError = () => {
    clearErrors();
    onRequestClose();
  };

  const modalContentKeys = error => {
    switch (error.code) {
      case errorCodes['hasExistingMembership']:
        return {
          title: 'plan_builder.existingSubscription.title',
          body: [
            {
              text: 'plan_builder.existingSubscription.body',
            },
          ],
          buttons: [
            {
              text: 'plan_builder.existingSubscription.edit_autoship',
              action: editAutoship,
            },
            {
              text: 'plan_builder.existingSubscription.shop_pods',
              action: shopPods,
            },
          ],
        };

      case errorCodes['hasAlreadyMetMonthlyLimit']:
        return {
          title: 'plan_builder.bulk_limit.title',
          body: [
            {
              text: 'plan_builder.bulk_limit.body',
            },
            {
              text: 'plan_builder.monthly_limit.remove_pods',
              values: { count: <b>{error.podQuantityToRemove}</b> },
            },
          ],
          buttons: [
            {
              text: 'plan_builder.bulk_limit.cancel_build_your_plan',
              action: exitBuildYourPlan,
            },
          ],
        };

      case errorCodes['newPlanExceedsMonthlyLimit']:
        return {
          title: 'plan_builder.monthly_limit.title',
          body: [
            {
              text: 'plan_builder.monthly_limit.body',
            },
            {
              text: 'plan_builder.monthly_limit.remove_pods',
              values: { count: <b>{error.podQuantityToRemove}</b> },
            },
          ],
          buttons: [
            {
              text: 'plan_builder.monthly_limit.edit_pods',
              action: clearError,
            },
          ],
        };

      // Should never not be able to match an error code as we share the key
      // between fron and backend. If you see this in local dev, controller is
      // returning a mysterious error code.
      // Also, changes in lib require a server restart, if you just added a new
      // error code
      default:
        return {
          title: 'Unknown error',
          body: [{ text: 'Unknown error' }],
          buttons: [],
        };
    }
  };

  const { title, body, buttons } = modalContentKeys(error);

  return (
    <Modal
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      closable={false}
      isOpen={modalActive}
      onRequestClose={onRequestClose}
      bodyClassName={'build-your-plan__modal-body'}
      overlayClassName={'build-your-plan__modal-overlay'}
    >
      <div
        id="build-your-plan__modal"
        className="Modal__body build-your-plan__modal"
      >
        <div>
          <div className="Modal__title">
            <h3>
              <TranslatedMessage id={title} />
            </h3>
          </div>
          <div className="Modal__text">
            {body.map(paragraph => (
              <p key={paragraph.text}>
                <TranslatedMessage
                  id={paragraph.text}
                  values={paragraph.values}
                />
              </p>
            ))}
          </div>
        </div>

        <div className="button-group">
          {buttons.map(button => (
            <Button
              key={button.text}
              className="Modal__button"
              onClick={() => button.action()}
            >
              <TranslatedMessage id={button.text} />
            </Button>
          ))}
        </div>
      </div>
    </Modal>
  );
}

const connectedCartErrorModal = connect(
  'order',
  actions
)(CartErrorModal);

connectedCartErrorModal.displayName = 'ConnectedCartErrorModal';

export default connectedCartErrorModal;
